<template>
  <div class="chart-container">
    <div class="va-subtitle" v-if="title">{{ title }}</div>
    <va-horizontal-bar
      :chartData="computedData"
      :options="computedOptions"
    ></va-horizontal-bar>
  </div>
</template>
<script>
//todo convert to TS
import { VaHorizontalBar } from "@/components/organisms/charts/ChartsWrappers";
import cloneDeep from "lodash/cloneDeep";
import Vue from "vue";

export default Vue.extend({
  components: { VaHorizontalBar },
  props: {
    title: {
      type: String,
      required: false,
    },
    chartData: {
      required: true,
    },
    chartOptions: {
      required: false,
      default() {
        return {};
      },
    },
    legend: {
      type: Boolean,
      required: false,
      default: false,
    },
    stacked: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    computedData() {
      const data = cloneDeep(this.chartData);
      if (data.datasets) {
        data.datasets = data.datasets.map((dataset, datasetIndex) => {
          if (!dataset.backgroundColor) {
            dataset.backgroundColor = dataset.data.map((val, index) => {
              const i = ((index + (datasetIndex % 10) + 10) % 10) + 1; //loop 10 possible colors
              return this.$vuetify.theme.currentTheme[`chart${i}`];
            });
          }
          // if (!dataset.borderColor) {
          //   dataset.borderColor = dataset.data.map(() => {
          //     return this.$vuetify.theme.currentTheme.chartBorder;
          //   });
          // }
          dataset.borderWidth = 0;
          return dataset;
        });
      }
      return data;
    },
    computedOptions() {
      const opt = cloneDeep(this.chartOptions);
      opt.responsive = true;
      opt.maintainAspectRatio = false;
      opt.legend = {
        display: this.legend,
        position: "bottom",
        labels: {
          usePointStyle: true,
          padding: 16,
          fontColor: this.$vuetify.theme.currentTheme.chartText,
        },
      };
      opt.tooltips = {
        enabled: true,
        backgroundColor: this.$vuetify.theme.currentTheme.navigation,
      };
      opt.scales = {
        offset: false,
        yAxes: [
          {
            stacked: this.stacked,
            ticks: {
              fontColor: this.$vuetify.theme.currentTheme.chartText,
              beginAtZero: true,
            },
            gridLines: {
              color: this.$vuetify.theme.currentTheme.chartLines,
            },
          },
        ],
        xAxes: [
          {
            stacked: this.stacked,
            ticks: {
              fontColor: this.$vuetify.theme.currentTheme.chartText,
              beginAtZero: true,
            },
            gridLines: {
              color: this.$vuetify.theme.currentTheme.chartLines,
            },
          },
        ],
      };
      return opt;
    },
  },
});
</script>

<style lang="scss" scoped>
.chart-container {
  position: relative;
  width: 100%;
}
</style>
